import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import AlertAsk from './alertAsk'
import { promptState, refreshIfGranted, registerWorker, snoozeAsk, subscribeAndStore } from './noti'

const PushPrompt = () => {
  const userId = useSelector(state => state.authReduse.id)
  const [open, setOpen] = useState(false)
  const [note, setNote] = useState('')

  useEffect(() => {
    registerWorker().catch(() => {})
  }, [])

  useEffect(() => {
    if (!userId) {
      setOpen(false)
      return undefined
    }
    let alive = true
    const run = async () => {
      const state = promptState()
      if (state === 'insecure') {
        if (alive) setNote('Open Pinweelo with https (or the Home Screen app) to get chat alerts.')
        return
      }
      if (state === 'refresh') {
        try { await refreshIfGranted(userId) } catch (_) {}
        return
      }
      if (state === 'ask' && alive) setOpen(true)
    }
    run()
    const onVisible = () => {
      if (document.visibilityState === 'visible') run()
    }
    document.addEventListener('visibilitychange', onVisible)
    const timer = window.setInterval(run, 15 * 60 * 1000)
    return () => {
      alive = false
      document.removeEventListener('visibilitychange', onVisible)
      window.clearInterval(timer)
    }
  }, [userId])

  if (note && !open) {
    return <p className="pushInsecureNote">{note}</p>
  }

  if (!open || !userId) return null

  return (
    <AlertAsk
      title="Turn on notifications so you still get chat messages when the app is closed."
      okayLabel="Allow"
      noLabel="Not now"
      okay={async () => {
        setOpen(false)
        try {
          const result = await subscribeAndStore(userId)
          if (!result.ok && result.permission === 'insecure') {
            setNote('Open Pinweelo with https (or the Home Screen app) to get chat alerts.')
          }
        } catch (_) {}
      }}
      no={() => {
        snoozeAsk()
        setOpen(false)
      }}
    />
  )
}

export default PushPrompt
